import React from 'react'

import MaskedField from './MaskedField'

function FormCpf(props) {
  return (
    <MaskedField mask="999.999.999-99" {...props} />
  )
}

export default FormCpf